document.addEventListener('DOMContentLoaded', () => {

    // Unix timestamp (in seconds) to count down to
    var manydays_number = Number(howmany_days)
    var twoDaysFromNow = (new Date().getTime() / 1000) + (86400 * manydays_number) + 1;
  
    // Set up FlipDown
    var flipdown = new FlipDown(twoDaysFromNow)
  
      // Start the countdown
      .start()
  
      // Do something when the countdown ends
      .ifEnded(() => {
        console.log('The countdown has ended!');
      });

      let body = document.body;
      body.querySelector('#flipdown').classList.toggle('flipdown__theme-light');
    // Toggle theme
    // var interval = setInterval(() => {
      // let body = document.body;
      // body.classList.toggle('light-theme');
      // body.querySelector('#flipdown').classList.toggle('flipdown__theme-dark');
      // body.querySelector('#flipdown').classList.toggle('flipdown__theme-light');
      // body.querySelector('#flipdown').classList.toggle('flipdown__theme-light');
    // }, 5000);
  
    // Show version number
    var ver = document.getElementById('ver');
    ver.innerHTML = flipdown.version;
  });
  